import { Injectable } from '@angular/core';
import { useQuery } from '@globalconnect/query';
import { saveAs } from 'file-saver';
import { filter, take } from 'rxjs';
import { RolloutProgressReportFilesApiService } from './api/rollout-progress-report-files-api.service';

@Injectable({
  providedIn: 'root',
})
export class RolloutProgressReportFilesService {
  constructor(
    private readonly apiService: RolloutProgressReportFilesApiService,
  ) {}

  getFile$ = (fileId: string) =>
    useQuery(['file', fileId], () =>
      this.apiService.getFile(fileId),
    ).getState$();

  downloadFiles = (files: { fileName: string; fileId: string }[]) => {
    files.forEach((file) => {
      this.getFile$(file.fileId)
        .pipe(
          filter((response) => !!response.data),
          take(1),
        )
        .subscribe((metaDataQueryResponse) => {
          if (metaDataQueryResponse.data) {
            const blob = metaDataQueryResponse.data.body;
            blob && saveAs(blob, file.fileName);
          }
        });
    });
  };
}
